module.exports = __webpack_public_path__ + "static/media/robo2.2fe572f6.png";